// extracted by mini-css-extract-plugin
export default {"pageWrap":"Jb-z","fullWidth":"Kb-z","heading":"Lb-z","fullBleed":"Mb-z","hidden":"Nb-z"};